/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Foot_LinkInputs */

const en_bot_foot_link = /** @type {(inputs: Bot_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot`)
};

const id_bot_foot_link = /** @type {(inputs: Bot_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot`)
};

/**
* | output |
* | --- |
* | "BystepBot" |
*
* @param {Bot_Foot_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_foot_link = /** @type {((inputs?: Bot_Foot_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Foot_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_foot_link(inputs)
	return en_bot_foot_link(inputs)
});